import {Component, Vue} from "vue-property-decorator";
import {CurrencyRepo} from "@services/repos/currencyRepo";

@Component
export default class SymbolMixin extends Vue {
  currencyRepo!: CurrencyRepo;

  //------------------------------------------

  constructor() {
    super();
    this.currencyRepo = new CurrencyRepo();
  }

  //------------------------------------------

  get _symbols(): any {
    return this.$store.getters['main/getSymbols'];
  }
  set _symbols(val: any) {
    this.$store.commit('main/setSymbols', val);
  }

  //------------------------------------------

  _symbolsRefresh() {
    return this.currencyRepo.getSymbols()
      .then((res: any) => {
        if (!res.data) return;
        this._symbols = this._symbolsGetObjectFromArray(res.data)
      });
  }

  _symbolsGetObjectFromArray(val: [object]): any {
    let items: any = {};
    val.forEach((item: any) => {
      items[item.id] = item;
    })
    return items;
  }

  _symbolsGetArray(): any {
    let items: any = [];
    for (let key in this._symbols) {
      items.push(this._symbols[key]);
    }
    return items;
  }

  _symbolGetBase(val: string): any {
    if (!this._symbols || !val) return null;
    let symbol = this._symbols[val] || {};
    return symbol.baseCurrency;
  }

  _symbolGetQuoted(val: string): any {
    if (!this._symbols || !val) return null;
    let symbol = this._symbols[val] || {};
    return symbol.quotedCurrency;
  }
}
